import React from 'react';
import { Card } from '@sravni/react-design-system/lib/Card';
import { Icon } from '@sravni/react-design-system/lib/Icon';
import { Space } from '@sravni/react-design-system/lib/Space';
import { Heading, Link, Text } from '@sravni/react-design-system/lib/Typography';
import { Message } from '@sravni/react-icons';
import { useIsMobile } from '@sravni/react-utils';
import { formatPhone } from '../../../helpers/formatPhone.js';
import modules_efad2c92 from '../styles/ContactsBanner.module.less.js';

const ContactsBanner = ({ variant, support, className, ...rest }) => {
    const { phone, supportStart, supportEnd, chatLink } = support;
    const isPrimary = variant === 'primary';
    const isMobile = useIsMobile();
    return (React.createElement(Card, { size: isMobile ? 16 : 24, color: isPrimary ? 'dark' : 'light', className: className, ...rest },
        React.createElement(Space, { size: 4, direction: "column", className: "h-ml-8 h-mr-8" },
            phone && React.createElement(Heading, { level: 4 }, formatPhone(phone)),
            React.createElement(Link, { href: chatLink, className: modules_efad2c92.link },
                React.createElement(Text, { size: 12 }, "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u0447\u0430\u0442 \u0432 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0438"),
                React.createElement(Icon, { size: 16, icon: React.createElement(Message, null) })),
            React.createElement(Text, { size: 12, className: "h-mt-12" }, `Служба заботы о\u00A0клиентах работает ежедневно с\u00A0${supportStart} до\u00A0${supportEnd} по\u00A0МСК`))));
};
ContactsBanner.displayName = 'ContactsBanner';

export { ContactsBanner };
//# sourceMappingURL=ContactsBanner.js.map
